'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var RowSection = function RowSection(_ref) {
  var content = _ref.content,
      colSpan = _ref.colSpan;
  return _react2.default.createElement('tr', null, _react2.default.createElement('td', {
    'data-toggle': 'collapse',
    colSpan: colSpan,
    className: 'react-bs-table-no-data'
  }, content));
};

RowSection.propTypes = {
  content: _propTypes2.default.any,
  colSpan: _propTypes2.default.number
};
RowSection.defaultProps = {
  content: null,
  colSpan: 1
};
exports.default = RowSection;